/* global Ladda */
(function ($) {
    'use strict';
    const keyCodes = {
        Enter: 13
    };
    $.widget("fd.control_button", {
        options: {
            parentid: null,
            value: null,
            disabled: false,
            stoppropagation: false,
            startladda: false,
            callback: function () {}
        },
        startLoading: function () {
            if (!this._laddaInstance) {
                this.element.addClass('ladda-button').attr('data-style', 'expand-right').append('<span class="ladda-spinner"></span>');
            }
            this._laddaInstance = Ladda.create(this.element[0]);
            this._laddaInstance.start();
        },
        stopLoading: function () {
            if (this._laddaInstance) {
                this._laddaInstance.stop();
            }
        },
        toggleLoading: function () {
            if (this._laddaInstance) {
                this._laddaInstance.toggle();
            } else {
                this.startLoading();
            }
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            this._setEvents();
        },
        _handleSubmit: function (event) {
            if (!this.options.disabled) {
                if (this.options.startladda) {
                    this.startLoading();
                }
                this.options.callback.call(this, { parentid: this.options.parentid, value: this.options.value }, event);
            }
        },
        _laddaInstance: null,
        _setEvents: function () {
            const self = this;
            this.element.off('click.fdcontrol keydown.fdcontrol')
                .on('click.fdcontrol', function (event) {
                    self._handleSubmit(event);
                    if (self.options.stoppropagation) {
                        event.stopPropagation();
                    }
                })
                .on('keydown.fdcontrol', function (event) {
                    if (event.which === keyCodes.Enter) {
                        self._handleSubmit(event);
                        if (self.options.stoppropagation) {
                            event.stopPropagation();
                        }
                    }
                });
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        }
    });
}(jQuery));